export const environment = {
   wsSocketUrl: 'wss://home.shiku.world',
   resourceUrl: 'https://resources.shiku.world/static',
   twitchAuthRedirect: 'https://shiku.world',
   mainDoorStatusUrl: 'https:///status.shiku.world/main-door-status',
   backDoorStatusUrl: 'https:///status.shiku.world/back-door-status',
};
